<form #form="ngForm" [formGroup]="loginForm" (ngSubmit)="login()" novalidate class="app-login-form">
  <mat-form-field class="app-validate">
    <mat-label>Användarnamn</mat-label>
    <input matInput formControlName="userName" id="userName" autocomplete="username" (keydown.enter)="enterKeyDown()" required>
    @if (userName.hasError('required')) {
      <mat-error>Användarnamn är obligatoriskt</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="app-validate">
    <mat-label>Lösenord</mat-label>
    <input matInput formControlName="password" id="password" autocomplete="current-password" (keydown.enter)="enterKeyDown()" type="password">
    @if (password.hasError('required')) {
      <mat-error>Lösenord är obligatoriskt</mat-error>
    }
  </mat-form-field>

  <mat-checkbox formControlName="rememberMe" (keydown.enter)="enterKeyDown()">Kom ihåg mig!</mat-checkbox>

</form>
